import { DefaultTheme } from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getToken, Size } from '@optimus-web/common';

export const getInputContainerHeight = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getToken(TokenName.SIZING_400);
        case 'medium':
            return getToken(TokenName.SIZING_500);
        case 'large':
            return getToken(TokenName.SIZING_600);
        default:
            return getToken(TokenName.SIZING_500);
    }
};

export const getInputPadding = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getToken(TokenName.SPACING_50);
        case 'medium':
            return getToken(TokenName.SPACING_100);
        case 'large':
            return getToken(TokenName.SPACING_150);
        default:
            return getToken(TokenName.SPACING_100);
    }
};

export const getPlaceholderPadding = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getToken(TokenName.SPACING_50);
        case 'medium':
            return getToken(TokenName.SPACING_100);
        case 'large':
            return getToken(TokenName.SPACING_150);
        default:
            return getToken(TokenName.SPACING_100);
    }
};

export const getContainerPadding = ({ inputSize }: { inputSize?: Size }) => {
    switch (inputSize) {
        case 'small':
            return getToken(TokenName.SPACING_100);
        case 'medium':
            return getToken(TokenName.SPACING_150);
        case 'large':
            return getToken(TokenName.SPACING_200);
        default:
            return getToken(TokenName.SPACING_150);
    }
};

export const getInputColor = ({
    disabled,
    readOnly,
    theme,
}: {
    disabled?: boolean;
    readOnly?: boolean;
    theme: DefaultTheme;
}) => {
    if (disabled) {
        return getToken(TokenName.TEXT_DISABLED)({ theme });
    } else if (readOnly) {
        return getToken(TokenName.TEXT_STATIC_SECONDARY)({ theme });
    }

    return getToken(TokenName.TEXT_STATIC_PRIMARY)({ theme });
};
